import { cineamoApiClient } from '../../apiClient';
import {
    NewsletterSectionCreateInputDto,
    NewsletterSectionDto,
    NewsletterSectionUpdateInputDto
} from '../../models/newsletter-section/NewsletterSectionDto.types';
import { ApiResponse } from '../../types/ApiResponse.types';

type NewsletterSectionListResponse = {
    _total_items: number;
    _page: number;
    _page_count: number;
    _embedded: {
        'newsletter-sections': NewsletterSectionDto[];
    };
};

export type GetNewsletterSectionsParams = {
    page?: number;
    perPage?: number;
    sort?: string;
    order?: string;
    configId?: number;
};

export async function getNewsletterSections(
    cinemaId: number,
    params: GetNewsletterSectionsParams = {}
): Promise<NewsletterSectionListResponse | null> {
    const { page = 1, perPage = 20, sort, order, configId } = params;
    const searchParams = new URLSearchParams();
    searchParams.set('page', String(page));
    searchParams.set('perPage', String(perPage));
    if (sort) searchParams.set('sort', sort);
    if (order) searchParams.set('order', order);
    if (configId !== undefined) searchParams.set('configId', String(configId));
    return cineamoApiClient
        .get<ApiResponse<NewsletterSectionListResponse>>(
            `/cinemas/${cinemaId}/newsletter/sections?${searchParams.toString()}`
        )
        .then((response) => response.data)
        .catch(() => null);
}

export async function getNewsletterSection(cinemaId: number, sectionId: number): Promise<NewsletterSectionDto | null> {
    return cineamoApiClient
        .get<ApiResponse<NewsletterSectionDto>>(`/cinemas/${cinemaId}/newsletter/sections/${sectionId}`)
        .then((response) => response.data)
        .catch(() => null);
}

export async function createNewsletterSection(
    cinemaId: number,
    data: NewsletterSectionCreateInputDto
): Promise<NewsletterSectionDto | null> {
    return cineamoApiClient
        .post<ApiResponse<NewsletterSectionDto>>(`/cinemas/${cinemaId}/newsletter/sections`, data)
        .then((response) => response.data)
        .catch(() => null);
}

export async function updateNewsletterSection(
    cinemaId: number,
    sectionId: number,
    data: NewsletterSectionUpdateInputDto
): Promise<NewsletterSectionDto | null> {
    return cineamoApiClient
        .patch<ApiResponse<NewsletterSectionDto>>(`/cinemas/${cinemaId}/newsletter/sections/${sectionId}`, data)
        .then((response) => response.data)
        .catch(() => null);
}

export async function deleteNewsletterSection(cinemaId: number, sectionId: number): Promise<boolean> {
    return cineamoApiClient
        .delete(`/cinemas/${cinemaId}/newsletter/sections/${sectionId}`)
        .then(() => true)
        .catch(() => false);
}
